
<ion-header>
  <ion-toolbar>
     <ion-buttons slot="start">
         <ion-button (click)="dismiss('back')">
            <ion-icon name="arrow-back" color="primary"></ion-icon>
          </ion-button>
      </ion-buttons>
      <ion-title>
        {{'NEW_SCHEDULE' | translate}}
      </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <ion-list>
    <plan-option *ngFor="let plan of planList" [item]="plan" (onClick)="click(plan.id)"></plan-option>
  </ion-list>
</ion-content>